import { FileTypeEnum } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'
import { BrowserUtil, RouterUtil, WeappUtil } from 'kuaidong-lib'

const Index = () => import('../views/student-auth-mgt/Index.vue')
const Clazz = () => import('../views/student-auth-mgt/Clazz.vue')
const Student = () => import('../views/student-auth-mgt/Student.vue')
const Settings = () => import('../views/student-auth-mgt/Settings.vue')
const StudentUpload = () => import('../views/student-auth-mgt/StudentUpload.vue')
const StudentUploadMapping = () => import('../views/student-auth-mgt/StudentUploadMapping.vue')

export const indexRoute: RouteConfig = {
  path: '/student-auth-mgt',
  name: 'student_auth_mgt',
  component: Index,
  meta: {
    title: '学生认证管理',
  },
}

export const clazzRoute: RouteConfig = {
  path: '/student-auth-mgt-clazz',
  name: 'student_auth_mgt_clazz',
  component: Clazz,
  props: (route) => ({ ...route.query, ...route.params, clazzId: +route.query.clazzId, gradeId: +route.query.gradeId }),
  meta: {
    title: '学生认证详情',
  },
}

export const studentRoute: RouteConfig = {
  path: '/student-auth-mgt-student',
  name: 'student_auth_mgt_student',
  component: Student,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生认证详情',
  },
}

export const settinsRoute: RouteConfig = {
  path: '/student-auth-mgt-settings',
  name: 'student_auth_mgt_settings',
  component: Settings,
  meta: {
    title: '学生认证管理',
  },
}

export const studentUploadRoute: RouteConfig = {
  path: '/student-auth-mgt-student-upload',
  name: 'student_auth_mgt_student_upload',
  component: StudentUpload,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '导入学生名单',
  },
}

export const studentUploadMappingRoute: RouteConfig = {
  path: '/student-auth-mgt-student-upload-mapping',
  name: 'student_auth_mgt_student_upload_mapping',
  component: StudentUploadMapping,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '核对匹配结果',
  },
}

export default [indexRoute, clazzRoute, studentRoute, settinsRoute, studentUploadRoute, studentUploadMappingRoute]

export function navigateToStudentAuthMgt(router: VueRouter) {
  router.push({ name: indexRoute.name })
}

export function navigateToStudentAuthMgtClazz(router: VueRouter, clazzId: number, gradeId: number) {
  router.push({ name: clazzRoute.name, query: { clazzId: `${clazzId}`, gradeId: `${gradeId}` } })
}

export function navigateToStudentAuthMgtStudent(router: VueRouter, studentId: string) {
  router.push({ name: studentRoute.name, query: { studentId } })
}

export function navigateToStudentAuthMgtSettings(router: VueRouter) {
  router.push({ name: settinsRoute.name })
}

export function navigateToStudentAuthMgtStudentUpload(router: VueRouter) {
  router.push({ name: studentUploadRoute.name })
}

export function navigateToStudentAuthMgtStudentUploadMapping(router: VueRouter, url: string, fromWeapp = false) {
  if (BrowserUtil.isWeapp()) {
    WeappUtil.chooseMessageFile(
      FileTypeEnum.Excel,
      RouterUtil.buildUrlFromRoute(studentUploadMappingRoute, { url }, router),
      fromWeapp
    )
  } else {
    router.push({
      name: studentUploadMappingRoute.name,
      query: { url },
    })
  }
}

export function redirectToStudentAuthMgtStudentUploadMapping(router: VueRouter, url: string, fromWeapp = false) {
  if (BrowserUtil.isWeapp()) {
    WeappUtil.chooseMessageFile(
      FileTypeEnum.Excel,
      RouterUtil.buildUrlFromRoute(studentUploadMappingRoute, { url }, router),
      fromWeapp
    )
    router.go(-1)
  } else {
    router.replace({
      name: studentUploadMappingRoute.name,
      query: { url },
    })
  }
}
